import { PAYMENT_PROVIDERS } from '@vy/types';
import { values } from '@vy/utils';
import React from 'react';
import type { StyledTextField } from '../StyledTextField';
import { BaseSelect } from './BaseSelect';

type PaymentProviderSelectProps = Omit<React.ComponentProps<typeof StyledTextField>, 'options'> & {
  textFieldProps?: React.InputHTMLAttributes<HTMLInputElement>;
  suffix?: string;
  suffixByFieldValue?: Record<string, string>;
  label?: string;
};

export const PaymentProviderSelect = React.forwardRef<HTMLInputElement, PaymentProviderSelectProps>(
  (props, ref) => {
    return <BaseSelect label="Payment Provider" {...props} ref={ref} values={values(PAYMENT_PROVIDERS)} />;
  },
);
